import { useEffect } from 'react'

import { navigate } from '@redwoodjs/router'

import { toast } from 'src/components/Overlays/Toast/Toast'

import { useFormContext } from '../utils/FormContext'

export const INCOMPLETE_APPLICATION_MESSAGE =
  'Some sections need attention before you can sign. Review the items marked Fix.'

/**
 * Signing screens only make sense for a complete application. While any
 * section would still be refused by its own step, send the driver to the
 * review page, where the rows say what to fix.
 */
export const useRequireCompleteApplication = () => {
  const { application, applicationId, hasIssues } = useFormContext()
  const blocked = Boolean(application) && hasIssues

  useEffect(() => {
    if (!blocked) return
    toast(INCOMPLETE_APPLICATION_MESSAGE, 'error')
    navigate(`/driver-application/review?applicationId=${applicationId}`, {
      replace: true,
    })
  }, [blocked, applicationId])

  return { blocked }
}
